/**
 * Created by XPL on 2018/3/20.
 */
import jsonp from "assets/js/jsonp";
import { commonParams, options, removePending, REQUEST_PREFIX } from "./config";
import axios from "api/axios";
import Qs from "qs";

const debug =
  process.env.NODE_ENV !== "production" &&
  process.env.NODE_ENV !== "production_testing";

export let getCodeUrl = debug
  ? "https://server.dev.eeidm.com/api/AccountUI/GetCheckCodeIMG"
  : REQUEST_PREFIX + "/AccountUI/GetCheckCodeIMG";

export function LoginCheckAPI(params, author) {
  var url = debug
    ? "/api/AccountUI/LoginCheckAPI"
    : `${REQUEST_PREFIX}/AccountUI/LoginCheckAPI`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ],
    headers: {
      Authorization: author
    }
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// V2版登录接口
export function LoginChecker(params, author) {
  var url = debug
    ? "/api/AccountUI/LoginChecker"
    : `${REQUEST_PREFIX}/AccountUI/LoginChecker`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ],
    headers: {
      Authorization: author
    }
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 手机登录发送验证码
// export function SendSMS(params, author) {
//   var url = debug ? '/api/AccountUI/SendSMS' : `${REQUEST_PREFIX}/AccountUI/SendSMS`
//   const data = Object.assign({}, {}, params)
//   return axios({
//     url: url,
//     method: 'get',
//     params: data
//   }).then((res) => {
//     return Promise.resolve(JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n")))
//   }).catch((err) => {
//     return Promise.reject(err)
//   })
// }

export function ResetPwd(params, author) {
  var url = debug
    ? "/api/AccountUI/ResetPassWord"
    : `${REQUEST_PREFIX}/AccountUI/ResetPassWord`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    headers: {
      Authorization: author
    },
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function CheckAuthCode(params, author) {
  var url = debug
    ? "/api/AccountUI/CheckAuthCode"
    : `${REQUEST_PREFIX}/AccountUI/CheckAuthCode`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function ResetPwdByPhone(params, author) {
  var url = debug
    ? "/api/AccountUI/ResetPwdByPhone"
    : `${REQUEST_PREFIX}/AccountUI/ResetPwdByPhone`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function ResetPwdByEmail(params, author) {
  var url = debug
    ? "/api/AccountUI/ResetPwdByEmail"
    : `${REQUEST_PREFIX}/AccountUI/ResetPwdByEmail`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function Register(params, author) {
  var url = debug
    ? "/api/AccountUI/Register"
    : `${REQUEST_PREFIX}/AccountUI/Register`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    headers: {
      Authorization: author
    },
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

export function LoginRegister(params, author) {
  var url = debug
    ? "/api/AccountUI/LoginRegister"
    : `${REQUEST_PREFIX}/AccountUI/LoginRegister`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    headers: {
      Authorization: author
    },
    transformRequest: [
      function(data) {
        // let ret = ''
        // for (let it in data) {
        //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        // }
        // return ret
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

export function SendSMS(params, author) {
  var url = debug
    ? "/api/AccountUI/SendSMS"
    : `${REQUEST_PREFIX}/AccountUI/SendSMS`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "get",
    params: data
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function SendEmail(params, author) {
  var url = debug
    ? "/api/AccountUI/SendEmail"
    : `${REQUEST_PREFIX}/AccountUI/SendEmail`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "get",
    params: data
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
export function loginOut(obj) {
  var url = debug
    ? "/api/AccountUI/LoginoutAPI"
    : `${REQUEST_PREFIX}/AccountUI/LoginoutAPI`;
  const data = Object.assign({}, commonParams, obj);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ],
    other: obj.other
  })
    .then(res => {
      return Promise.resolve(JSON.parse(res.data));
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 微信授权
export function UserGinterface(params) {
  var url = debug
    ? "/api/AccountUI/UserGinterface"
    : `${REQUEST_PREFIX}/AccountUI/UserGinterface`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "get",
    params: data
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 邀请注册
export function InviteLoginRegister(params, author) {
  var url = debug
    ? "/api/AccountUI/InviteLoginRegister"
    : `${REQUEST_PREFIX}/AccountUI/InviteLoginRegister`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    headers: {
      Authorization: author
    },
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 获取业务员信息
export function GetSalesManInfo(params) {
  var url = debug
    ? "/api/CustomerInfo/GetSalesManInfo"
    : `${REQUEST_PREFIX}/CustomerInfo/GetSalesManInfo`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "get",
    params: data
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 活动注册
export function ActivityRegister(params, author) {
  var url = debug
    ? "/api/AccountUI/ActivityRegister"
    : `${REQUEST_PREFIX}/AccountUI/ActivityRegister`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    headers: {
      Authorization: author
    },
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(
        JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n"))
      );
    })
    .catch(err => {
      return Promise.reject(err);
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js